import { Recipient } from '@microsoft/microsoft-graph-types';
import { AiBlockType, DynamicOutputKey, IntegrationAuthApp, Prisma } from '@prisma/client';

export type { IntegrationAppAuthentications } from '@prisma/client';

export interface DynamicTagImageType {
  src: string;
  alt: string;
}

export enum NangoIntegrationProvider {
  GOOGLE = 'google',
  GSHEETS = 'gsheets',
  ZENDESK = 'zendesk',
  MICROSOFT_TEAMS = 'microsoft-teams',
  FRONT = 'front',
  SLACK = 'slack',
  HUBSPOT = 'hubspot',
  FRESHDESK = 'freshservice',
  GW = 'gw',
  MICROSOFT_OAUTH2_CC = 'microsoft-oauth2-cc',
}

/*
 Even tho CustomIntegrationProvider and CustomApp looks the same, the semantic is different.
 A CustomIntegrationProvider is a provider that is not part of the NangoIntegrationProvider enum,
 but is needed to fulfill the shape of an integration.

 A CustomApp is a representation of an integration without a connection to a provider.
 **/
export enum CustomIntegrationProvider {
  NETWORK = 'network',
  WEBHOOK = 'webhook',
  CUSTOM_CODE = 'customCode',
  AI_BLOCK = 'ai-block',
  DEVELOPMENT = 'development',
}

export enum CustomApp {
  AI_BLOCK = 'aiBlock',
}
export interface OutlookBaseEmailObject {
  toRecipients: Recipient[];
  comment?: string;
}
export interface IntegrationOperationTrigger {
  id: string;
  description: string;
}

export interface IntegrationOperationTarget {
  id: string;
  description: string;
  compatibleWith: string[];
}

export interface Integration {
  id: IntegrationAuthApp;
  provider: NangoIntegrationProvider | CustomIntegrationProvider;
  title: string;
  icon: string;
  triggers: IntegrationOperationTrigger[];
  targets: IntegrationOperationTarget[];
}

export { IntegrationAuthApp };

// #region Dynamic Output Keys
interface Identifiable {
  id: string;
}

export interface UnidentifiedDynamicOutputKey {
  name: string;
  code: string;
  default: boolean;
  rawName: string;
  connectedNodeId: string;
  provider: string;
}

export interface UnidentifiedDynamicOutputKeyWithLabel extends UnidentifiedDynamicOutputKey {
  labelId: string;
  aiBlockId: string;
  aiBlockType: AiBlockTypeKey;
}

export interface DynamicOutputKeyDeleteProps {
  name: string;
  connectedNodeId: string;
  aiBlockType: AiBlockTypeKey;
  onSuccess?: () => void;
}
export interface AppMetadata {
  integration: string;
  operationId: string;
  aiBlockType?: string;
  aiBlockId?: string;
}

export type NodeMetadata = AppMetadata | Prisma.JsonValue;

export interface NodeWithBaseDynamicOutputKeys extends Identifiable {
  metadata: NodeMetadata;
  dynamicOutputKeys: DynamicOutputKey[];
}

export interface NodeWithExtendedDynamicOutputKeys {
  integration: string;
  operation: string;
  nodeId: string;
  dynamicOutputKeys: DynamicOutputKey[];
}

export interface FlowVersion extends Identifiable {
  nodes: NodeWithBaseDynamicOutputKeys[];
}

export interface FlowDataWithDynamicOutputKeys extends Identifiable {
  versions: FlowVersion[];
}

export interface AddDynamicOutputKeyHook {
  name: string;
  selectedNodeId: string;
  provider: string;
}

export interface UpdateDynamicOutputKeyFromLabelHook extends AddDynamicOutputKeyHook {
  labelId: string;
  aiBlockId: string;
  aiBlockType: AiBlockTypeKey;
  onSuccess?: () => void;
}

export type AiBlockTypeKey = keyof typeof AiBlockType;

export interface UpdateDynamicOutputKeyNameProps {
  dynamicOutputId: string;
  name: string;
}
// #endregion Dynamic Output Keys
